import * as React from 'react';
import { SegmentationLegend as Legend } from '@mentimeter/visualizations';
import { VisualizationUpdater } from '@mentimeter/question-modules-shared';
import type { SegmentT } from '@mentimeter/http-clients';

interface PropsT {
  selector: string;
  title: string;
  segments: SegmentT[];
  chartWidth: number;
  chartHeight: number;
  width: number;
  margin?: number;
  colors: string[];
  lineColor: string;
  textColor: string;
}

const SegmentationLegend = React.memo<PropsT>(
  ({
    selector,
    title,
    segments = [],
    chartWidth,
    chartHeight,
    width,
    margin = 0,
    colors,
    textColor,
    lineColor,
  }: PropsT) => {
    const legend = new Legend({
      selector: `#${selector}`,
      colors,
      segments,
      title,
      textColor,
      width,
    });

    const height = legend.getHeight();

    return (
      <>
        <VisualizationUpdater updateFn={legend.update} />
        <svg
          data-testid="segmentation-legend"
          width={width}
          x={chartWidth + margin}
          y={chartHeight / 2 - height / 2}
          style={{ overflow: 'visible' }}
        >
          <line
            x1={0}
            x2={0}
            y1={0}
            y2={height}
            stroke={lineColor}
            strokeWidth={3}
          />
          <g id={selector} />
        </svg>
      </>
    );
  },
);

export default SegmentationLegend;
